<webrtc-player #webrtcPlayer
               uiFullscreenTarget
               #fs="uiFullscreenTarget"
               [lockLandscape]="true"
               [isTileInFullscreen]="fs.isFullscreen()"
               [edgeId]="edgeId"
               [cameraId]="cameraId"
               [locationId]="locationId"
               [cameraName]="cameraName"
               [autostart]="true"
               [allowZoom]="true"
               [accessToken]="accessToken"
               [permissionCheck]="false"
               [isRespectRatio]="isRespectRatio"
               [defaultResolution]="defaultResolution"
               [forceShowQualitySelector]="true"
               class="h-100"
               (clickTakeSnapshot)="webrtcPlayer.takeSnapshot(cameraName, location?.name, now)"
               (clickFullScreen)="fs.toggle()"
>
</webrtc-player>
